import FilterIcon from '@/components/icons/FilterIcon';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

type Props = {
	isMobile?: boolean;
};

const AccountLogs: FC<Props> = ({ isMobile }) => {
	const { t } = useTranslation();

	return (
		<div className='flex flex-col gap-4 select-none'>
			<div className='flex items-center justify-between gap-2'>
				<h3 className={cn(isMobile && 'text-base')}>
					{t('main.account.components.logs.title')}
				</h3>
				<Button
					variant='outline'
					size={isMobile ? 'icon' : 'default'}>
					<FilterIcon />
					{!isMobile && t('elements.buttons.filter')}
				</Button>
			</div>
			<div
				className={cn(
					'p-6 flex flex-col gap-4 border border-popover-100 rounded-2.5xl bg-popover-10',
					isMobile && 'p-0 border-0 bg-popover-30',
				)}>
				...
			</div>
		</div>
	);
};

export default AccountLogs;
